<template>
    <div class="dynamic-table">
      <el-table
       ref="table"
      :key="refreshDynamicTableKey"
      :show-summary="showSummary"
      :data="tableData"
      :height="tableAutoHeight"
      :row-style="setRowStyle"
      :style="dtStyle"
      :border="true"
      v-loading="isLoading"
      tooltip-effect="dark"
      :span-method="cellMerge"
      @row-click="handleRowClick"
      @row-dblclick="handleRowDblclick"
      @selection-change="handleSelectionChange"
      :summary-method="getSummaries"
      @sort-change="sortChange"
      @filter-change="filterChange">
            <el-table-column  v-if="isShowCheckbox" type="selection" align="center" min-width="30px"></el-table-column>
                <template v-for="(column, index) in tableColumns">
                    <!-- 这里使用key=index 才能保证列出现的顺序 -->
                    <el-table-column
                        v-if="column.type==='index'"
                        :key="index"
                        :prop="dragTableColumns?dragTableColumns[index].prop:column.prop"
                        :label="column.label"
                        :show-overflow-tooltip="isShowOverflowTooltip"
                        width="48"
                    />
                    <el-table-column
                        v-else-if="isViewApprovalInfo && column.prop == 'approvalStatus'"
                        :key="index"
                        :prop="dragTableColumns?dragTableColumns[index].prop:column.prop"
                        :label="column.label"
                        fixed="right"
                        :show-overflow-tooltip="isShowOverflowTooltip"
                        :column-key="'approvalStatusFilterKey'"
                        :filters="[{value: '0', text: '草稿'}, {value: '1', text: '审批中'}, {value: '2', text: '通过'}, {value: '3', text: '驳回'}]"
                        min-width="95px"
                    />
                    <el-table-column
                        v-else-if="isViewApprovalInfo && column.prop == 'approvalResultDetail'"
                        :key="index"
                        :prop="dragTableColumns?dragTableColumns[index].prop:column.prop"
                        :label="column.label"
                        fixed="right"
                        :isShowOverflowTooltip="isShowOverflowTooltip"
                    >
                        <template slot-scope="scope" >
                            <DynamicApprovalColumn
                                :isShowOverflowTooltip="isShowOverflowTooltip"
                                :column="column"
                                :approvalTableData="getApprovalList(scope.row['approvalInstanceId'])"
                                :cellValue="scope.row[column.prop]"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-else-if="column.type==='text' && column.prop!='processInstanceName' && column.prop != 'approvalStatus' && column.prop != 'approvalResultDetail'"
                        :key="index"
                        :prop="dragTableColumns?dragTableColumns[index].prop:column.prop"
                        :label="column.label"
                        :sortable="column.isAggregate"
                        :show-overflow-tooltip="isShowOverflowTooltip"
                    >
                    <!--    :render-header="labelHead" -->
                    <!-- TODO 这里需要进行鼠标移动表头变化的事件效果，后续补充 -->

                    <!-- <template slot="header" slot-scope="scope" >
                        {{column.label}}
                        <el-button type="success" icon="el-icon-search" circle @click="filterHead(column)"> </el-button>
                     <span @mouseout.stop="titleMouseout($event,column)" @mouseover.stop="titleMouseover($event,column)">{{column.label}}</span>
                      <div v-if="column.isShowSearchBtn" style="cursor: pointer;" >
                        <i class="icon-other-xuanzhong2x"></i>
                      </div>
                    </template>   -->
                    <template slot="header" slot-scope="scope" >
                        <!-- <div class="header-label"> -->
                            <span>{{column.label}}</span>
                            <i v-if="!column.isAggregate" style="cursor: pointer;" class="el-icon-search header-label-icon" @click.stop="filterHead(column)"></i>
                        <!-- </div> -->
                    </template>

                      <!-- TODO :需要进行升级的交互逻辑 -->
                      <!-- <template slot="header" slot-scope="scope">
                        <el-popover
                            placement="bottom"
                            width="180"
                            trigger="click">
                            <div slot="reference">
                                <span  > {{column.label}}</span>
                                <i style="cursor: pointer;" class="el-icon-arrow-down"></i>
                            </div>
                            <el-row>
                              <el-col :span="18">快捷筛选</el-col>
                              <el-col :span="6"><span style="cursor: pointer;color:#ff3b30">清空</span></el-col>
                            </el-row>
                            <el-row>
                              <el-input v-model="searchInputKey" placeholder="请输入关键词"></el-input>
                            </el-row>
                            <div class="center-menu">
                              <div class="menu-system">
                                <div class="menu-system-item">
                                  <div class="menu-system-item-child-group">
                                    <div class="menu-system-child">
                                      <div class="menu-system-child-item" @click.stop="filterHead(column)">
                                        <i class="iconfont icon-other-shenpiliu bc-custom-menu" style="color: rgb(255, 0, 255);"></i>筛选及排序
                                      </div>
                                      <div class="menu-system-child-item" @click.stop="freezeHead(column)">
                                        <i class="iconfont icon-other-yuangong bc-custom-menu" style="color: rgb(176, 46, 242);"></i>冻结
                                      </div>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-popover>
                      </template> -->
                      <template slot-scope="scope" >
                        <a style="cursor: pointer;" href="javascript:;"
                          v-if="scope.row[column.prop+'-ext1']" @click.stop="jumpLinks(scope.row[column.prop+'-ext1'])">{{scope.row[column.prop]}}</a>
                          <a style="cursor: pointer;" v-else-if="column.otherSetting && column.otherSetting.key==='1'">
                            <el-tag  type="warning" icon="el-icon-document" size="medium">查看详细内容</el-tag>
                          </a>
                          <a style="cursor: pointer;" href="javascript:;" v-else-if="column.isAggregate&&scope.row[column.prop]&&scope.row[column.prop]!=='0'" >
                            <template v-if="column.aggregateFieldId"><el-tag @click.stop="showAggregateDetail(scope.row,column)" type="danger"> {{scope.row[column.prop] | moneyFomater}}</el-tag></template>
                            <template v-else><el-tag type="warning">{{scope.row[column.prop] | moneyFomater}}</el-tag></template>
                          </a>
                          <a v-else>{{scope.row[column.prop]}}</a>
                      </template>
                    </el-table-column>

                     <el-table-column
                           v-else-if="column.type==='select' || column.type==='category'"
                           :key="index"
                           :prop="dragTableColumns?dragTableColumns[index].prop:column.prop"
                           :label="column.label"
                           :show-overflow-tooltip="isShowOverflowTooltip"
                       >
                       <template slot="header" slot-scope="scope" >
                        <div class="header-label">
                            <span > {{column.label}}</span>
                            <i style="cursor: pointer;" class="el-icon-search header-label-icon" @click.stop="filterHead(column)"></i>
                        </div>
                      </template>
                       <template slot-scope="scope">
                           <div v-if="column.otherSetting" >
                               <span v-for="(obj,i) in column.otherSetting.colorOne" :key="i" v-if="scope.row[column.id]&&(scope.row[column.id].split(',').indexOf(obj.value) != -1)"
                                                :style="'color:'+obj.ext1+';background:'+obj.ext2+';width:auto;padding: 0 10px;height:30px;display:inline-block;line-height:30px;border-radius: 4px;text-align: center;margin-right:6px;' ">
                                  {{obj.title}}
                              </span>
                           </div>
                          <div v-else>
                              <span>
                                  {{scope.row[column.prop]}}
                              </span>
                          </div>
                        </template>
                       </el-table-column>

                    <el-table-column
                          v-else-if="column.type==='number' || column.type==='calculation'"
                          :key="index"
                          :prop="dragTableColumns?dragTableColumns[index].prop:column.prop"
                          :label="column.label"
                          :show-overflow-tooltip="isShowOverflowTooltip"
                          sortable
                      >
                      <!-- sortable -->
                      <template slot="header" slot-scope="scope" >
                        <!-- <div class="header-label"> -->
                        <span > {{column.label}}</span>
                        <i style="cursor: pointer;" class="el-icon-search header-label-icon" @click.stop="filterHead(column)"></i>
                        <!-- </div> -->
                      </template>
                     <template slot-scope="scope">
                            <div v-if="column.moneyFormat">
                                <span v-if="column.otherSetting&&(Number(scope.row[column.id])>Number(column.otherSetting.numVal))" :style="'color:'+column.otherSetting.numColor+';'">
                                    {{scope.row[column.prop] | moneyFomater}}
                                </span>
                                <span v-else>
                                    {{scope.row[column.prop] | moneyFomater}}
                                </span>
                            </div>
                            <div v-else-if="column.isProgress">
                              <!-- <el-progress :text-inside="true" v-if="getProgressStatus(scope.row,column)" :status="scope.row | getProgressStatus(column)"  :stroke-width="20" :percentage="Number(scope.row[column.prop])"></el-progress>  -->
                              <el-progress :text-inside="true" v-if="getProgressStatus(scope.row,column)" :status="getProgressStatus(scope.row,column)"  :stroke-width="20" :percentage="scope.row[column.prop]?Number(scope.row[column.prop]):0"></el-progress>
                              <el-progress :text-inside="true" v-else :stroke-width="20"  :percentage="scope.row[column.prop]?Number(scope.row[column.prop]):0"></el-progress>
                           </div>
                            <div v-else>
                                <span v-if="column.otherSetting&&(Number(scope.row[column.id])>Number(column.otherSetting.numVal))" :style="'color:'+column.otherSetting.numColor+';'">
                                    {{scope.row[column.prop]}}
                                </span>
                                <span v-else>
                                    {{scope.row[column.prop]}}
                                </span>
                            </div>
                       </template>
                    </el-table-column>

                    <el-table-column
                          v-else-if="column.type==='date'"
                          :key="index"
                          :prop="dragTableColumns?dragTableColumns[index].prop:column.prop"
                          :label="column.label"
                          :show-overflow-tooltip="isShowOverflowTooltip"
                          sortable
                      >
                      <!-- sortable -->
                      <template slot="header" slot-scope="scope" >
                        <!-- <div class="header-label"> -->
                            <span > {{column.label}}</span>
                            <i style="cursor: pointer;" class="el-icon-search header-label-icon" @click.stop="filterHead(column)"></i>
                        <!-- </div> -->
                      </template>
                        <template slot-scope="scope">
                            <div v-if="column.dateFormat">
                                <span v-if="column.dateFormat==='yyyy'">
                                    {{scope.row[column.prop] | moneyYFomater}}
                                </span>
                                <span v-else-if="column.dateFormat==='yyyy-MM'">
                                    {{scope.row[column.prop] | moneyYMFomater}}
                                </span>
                                <span v-else>
                                    {{scope.row[column.prop]}}
                                </span>
                            </div>
                            <div v-else>
                                <span>
                                    {{scope.row[column.prop]}}
                                </span>
                            </div>
                       </template>
                    </el-table-column>

                    <el-table-column
                        v-else-if="column.type==='file'"
                        :key="index"
                        :prop="dragTableColumns?dragTableColumns[index].prop:column.prop"
                        :label="column.label"
                        min-width="95px"
                    >
                     <!-- :sortable="column.subcolumn?false:isSortable" -->
                        <template slot-scope="scope" >
                            <DynamicFileColumn
                                v-if="scope.row[column.prop]"
                                :isShowOverflowTooltip="isShowOverflowTooltip"
                                :column="column"
                                :fileTableData="scope.row[column.id]"
                                :cellValue="scope.row[column.prop]"
                            />
                        </template>
                    </el-table-column>

                     <el-table-column
                        v-else-if="column.type==='archive'"
                        :key="index"
                        :prop="dragTableColumns?dragTableColumns[index].prop:column.prop"
                        :label="column.label"
                    >
                            <!-- :sortable="column.subcolumn?false:isSortable" -->
                        <template slot-scope="scope" >
                            <el-tag  type="warning" icon="el-icon-folder" size="medium">查看详情</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column
                        v-else-if="isShowProcessInfo && column.prop==='processInstanceName'"
                        :key="index"
                        :prop="dragTableColumns?dragTableColumns[index].prop:column.prop"
                        fixed="right"
                        label="关联流程"
                        min-width="220px">
                         <template slot-scope="scope" >
                            <DynamicProcessColumn
                                v-if="scope.row[column.prop]"
                                :isShowOverflowTooltip="isShowOverflowTooltip"
                                :column="column"
                                :cellValue="scope.row[column.prop]"
                                :processInstanceId="scope.row['processInstanceId']"
                                :processInstanceName="scope.row['processInstanceName']"
                                :processInstanceStatus="scope.row['processInstanceStatus']"
                                :createdByName="scope.row['createdByName']"
                                :createdDate="scope.row['createdDate']"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-else-if="column.prop != 'approvalStatus' && column.prop != 'approvalResultDetail'"
                        :key="index"
                        :prop="dragTableColumns?dragTableColumns[index].prop:column.prop"
                        :label="column.label"
                        :show-overflow-tooltip="isShowOverflowTooltip"
                        :sortable="(column.type==='serialNumber' || column.type==='subFormSummary' || column.type==='date' || column.type==='user' || column.type==='department' || column.type==='position')?true:false"
                        min-width="95px"
                    >
                    <!-- :sortable="(column.type==='serialNumber' || column.type==='subFormSummary' || column.type==='date' || column.type==='user' || column.type==='department' || column.type==='position')?true:false" -->
                    <template slot="header" slot-scope="scope" >
                        <!-- <div class="header-label"> -->
                            <span > {{column.label}}</span>
                            <i style="cursor: pointer;" class="el-icon-search header-label-icon" @click.stop="filterHead(column)"></i>
                        <!-- </div> -->
                    </template>
                    <!-- :sortable="column.subcolumn?false:isSortable" -->
                      <template v-if="column.subcolumn" >
                        <template v-for="(subColumn, subIndex) in column.subColumns">
                            <el-table-column
                                v-if="subColumn.type==='file'"
                                :key="subIndex"
                                :prop="subColumn.prop"
                                :label="subColumn.label"
                                min-width="95px"
                            >
                                <!-- :sortable="isSortable" -->
                                <template slot-scope="scope" >
                                    <DynamicFileColumn
                                        v-if="scope.row[subColumn.prop]"
                                        :isShowOverflowTooltip="isShowOverflowTooltip"
                                        :column="subColumn"
                                        :fileTableData="scope.row[subColumn.id]"
                                        :cellValue="scope.row[subColumn.prop]"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-else
                                :key="subIndex"
                                :prop="subColumn.prop"
                                :label="subColumn.label"
                                :show-overflow-tooltip="isShowOverflowTooltip"
                                min-width="95px"
                            />
                                    <!-- :sortable="isSortable" -->
                          </template>
                      </template>
                    </el-table-column>
                </template>
                <slot name="options"></slot>
                <el-table-column
                    v-if="showBtnsColumn"
                    fixed="right"
                    label="操作"
                    align="center"
                    width="60">
                    <template slot-scope="scope">
                        <el-popover
                            placement="top"
                            width="80"
                            trigger="hover">
                            <div class="opera-form-btn">
                                <span class="opera-form-btn-item" @click="handleRowClick(scope.row,scope.column)">查看</span>
                                <span class="opera-form-btn-item" @click="handleRowClick(scope.row,scope.column)">编辑</span>
                                <span class="opera-form-btn-item" @click="deleteRowClick(scope.row,scope.column)">删除</span>
                            </div>
                            <span slot="reference" type="text" size="small" @click.stop style="color:#cd0000;">操作</span>
                        </el-popover>
                    </template>
                </el-table-column>
        </el-table>
        <br />
        <el-row v-if="pager && tableData.length>0 && !hiddenPage" type="flex" justify="end">
            <el-pagination
                v-if="!isShowPageSizes"
                background
                layout="total, prev, pager, next"
                :total="pager.totalPageNum"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                @current-change="handleQueryData"
            />
            <el-pagination
                v-if="isShowPageSizes"
                background
                layout="total, sizes, prev, pager, next"
                :total="pager.totalPageNum"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :page-sizes="[10, 20, 30, 50, 100, 300, ,10000]"
                @current-change="handleQueryData"
                @size-change="handleQueryDataByPageSize"
            />
        </el-row>
        <el-dialog
            title="选择复制文件"
            top="4vh"
            width="85%"
            :visible.sync="isShowFieldItemArchive"
            append-to-body
        >
        <FieldItemArchive ref="fieldItemArchive" v-if="isShowFieldItemArchive" :isRead="true" :key="loadTimer" :field="field" :formData="formData"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowFieldItemArchive = false">取 消</el-button>
          </span>
        </el-dialog>
        <el-dialog
              title="查看富文本详细内容"
              top="4vh"
              width="85%"
              :visible.sync="isShowRichtextContent"
              append-to-body
          >
              <div :key="loadTimer" class="richtext-content">
                  <p v-html="richtextContent"></p>
              </div>
              <span slot="footer" class="dialog-footer">
              <el-button @click="isShowRichtextContent = false">取 消</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="aggregateFormName" class="popModelFormList" width="95%" top="1vh" :fullscreen="true" append-to-body :visible.sync="isShowModelFormList" @close="hideDialog" v-if="isShowModelFormList">
          <ModelFormList
            v-if="isShowModelFormList"
            ref="formListChild"
            :key="loadTimerModelFormList"
            :formBtnAuth="formBtnAuth"
            :selectedModel="aggregateSelectedModel"
            :minuend="80"
            :fullScreen="false"
            :isShowAggregateList="true"
        />
      </el-dialog>
      <el-dialog title="设置查询条件"
          append-to-body
          top="4vh"
          custom-class="search-box"
          v-if="isShowSearchConditon"
          :visible.sync="isShowSearchConditon">
          <div @keyup.enter="chooseSearchConditon">
            <SearchCondition
                :key="searchLoaderTime"
                v-if="isShowSearchConditon"
                ref="searchConditon"
                :conditionFields="conditionFields"
                :isShowLeftModel="false"
                :currentColumn="currentColumn"
                @chooseSearchConditon="chooseSearchConditon" />
          </div>     
            <span slot="footer" class="dialog-footer">
                <el-button @click="resetSearchConditon">重置</el-button>
                <el-button type="primary" @click="chooseSearchConditon">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import FieldItemArchive from '@/components/FieldItem/FieldItemArchive';
import DynamicArchiveColumn from './DynamicArchiveColumn';
import DynamicFileColumn from './DynamicFileColumn';
import DynamicProcessColumn from './DynamicProcessColumn';
import DynamicApprovalColumn from './DynamicApprovalColumn';
import ModelFormList from '@/pages/business/BusinessApplication/ModelFormList';
import { getFormFieldListByIds } from '@/data-model';
import { isEmpty, cloneDeep } from 'lodash';

export default {
    components: {
        FieldItemArchive,
        DynamicFileColumn,
        DynamicProcessColumn,
        DynamicApprovalColumn,
        DynamicArchiveColumn,
        ModelFormList
    },
    data () {
        return {
            spanArr: [],
            pos: '',
            refreshDynamicTableKey: new Date().getTime(),
            loadTimer: '',
            maxOperIndex: 0,
            tableAutoHeight: 'auto',
            isShowFieldItemArchive: false,
            field: {},
            formData: {},
            selectArchiveField: '',
            arhiveFieldList: [],
            richtextContent: '',
            isShowRichtextContent: false,
            isShowModelFormList: false,
            loadTimerModelFormList: new Date().getTime(),
            formBtnAuth: {
                isShowView: false, // 查看
                isShowAdd: false, // 新增
                isShowEdit: false, // 修改
                isShowDelete: false, // 删除
                isShowImport: false, // 导入
                isShowExport: true, // 导出
                isShowSyn: false, // 同步流程数据
                isShowConfig: false // 进入应用配置
            },
            aggregateSelectedModel: {},
            aggregateFormName: '',
            searchLoaderTime: new Date().getTime(),
            isShowSearchConditon: false,
            conditionFields: [],
            searchInputKey: '',
            currentColumn: null
        };
    },
    filters: {
        moneyFomater: function (value) {
            if (!value) {
                return '0.00';
            } else if (isNaN(value)) {
                return value;
            }
            /* 原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1 */
            let intPart = Number(value) | 0; // 获取整数部分
            let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断
            let floatPart = '.00'; // 预定义小数部分
            // console.log(888,value)
            // console.log(888,typeof(value))
            let value2Array = value.toString().split('.');
            let isNegtiveNo = '';
            if (intPartFormat === 0) {
                if (value.toString().indexOf('-') !== 1) {
                    isNegtiveNo = '-'; // 修复小于0负数丢失的问题
                }
            }
            // =2表示数据有小数位
            if (value2Array.length === 2) {
                floatPart = value2Array[1].toString(); // 拿到小数部分
                if (floatPart.length === 1) { // 补0,实际上用不着
                    return isNegtiveNo + intPartFormat + '.' + floatPart + '0';
                } else {
                    return isNegtiveNo + intPartFormat + '.' + floatPart;
                }
            } else {
                return isNegtiveNo + intPartFormat + floatPart;
            }
        },
        moneyYFomater: function (value) {
            if (!value) {
                return '';
            }
            if (value.length > 4) {
                return value.substr(0, 4);
            } else {
                return value;
            }
        },
        moneyYMFomater: function (value) {
            if (!value) {
                return '';
            }
            if (value.length > 7) {
                return value.substr(0, 7);
            } else {
                return value;
            }
        },
        getProgressStatus (value, column) {
            return this.getProgressStatus(value, column);
        }
    },
    props: {
        showSummary: {// 是否要显示求和
            type: Boolean,
            default: false
        },
        isShowOverflowTooltip: {
            type: Boolean,
            default: false
        },
        isShowCheckbox: { // 显示checkbox
            type: Boolean,
            default: false
        },
        isSortable: { // 显示排序
            type: Boolean,
            default: false
        },
        isLoading: { // 是否显示loading
            type: Boolean,
            default: false
        },
        dtStyle: {
            type: String,
            default: 'width: 100vw'
        },
        tableHeight: { // 列表中需要显示的字段
            type: String
        },
        tableColumns: { // 列表中需要显示的字段
            type: Array
        },
        dragTableColumns: { // 列表中需要拖拽显示的字段
            type: Array
        },
        fieldsList: {// 字段属性列表
            type: Array
        },
        subformFieldsList: {// 字段属性列表
            type: Array
        },
        subformTableColumns: { // 列表中需要显示的字段
            type: Array
            // default: () => { return []; }
        },
        tableData: { // 列表数据
            type: Array
        },
        approvalList: {
            type: Array
        },
        pager: {
            type: Object
        },
        isSubform: { // 是否需要子表单的合并效果
            type: Boolean,
            default: false
        },
        isShowPageSizes: { // 是否显示每页条数选择框
            type: Boolean,
            default: false
        },
        autoHeight: {
            type: Boolean,
            default: false
        },
        isShowProcessInfo: { // 是否显示流程信息
            type: Boolean,
            default: false
        },
        isViewApprovalInfo: {// 是否显示审批状态和审批详情
            type: Boolean,
            default: false
        },
        minuend: {
            type: Number,
            default: 80
        },
        selectedModel: { // 当前模型
            type: Object
        },
        hiddenPage: {
            type: Boolean,
            default: false
        },
        showBtnsColumn: {
            type: Boolean,
            default: false
        },
        showMoreSearch: {
            type: Boolean,
            default: false
        },
        conditionLocalMap: {
            type: Map
        }
    },
    created () {
        if (this.isSubform) {
            this.setMergeSpanArr(this.tableData);
        }
    },
    mounted: function () {
        this.$nextTick(function () {
            if (!this.showMoreSearch) {
                if (this.$refs.hasOwnProperty('table')) { // hasOwnProperty
                    if (this.autoHeight) {
                        setTimeout(() => { // 此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
                            if (this.$refs.table && this.$refs.table.$el) {
                                this.tableAutoHeight = window.innerHeight - this.$refs.table.$el.offsetTop - this.minuend;
                            }
                        }, 300);
                        // 监听窗口大小变化
                        let self = this;
                        window.onresize = function () {
                            if (self.$refs.table && self.$refs.table.$el) {
                                self.tableAutoHeight = window.innerHeight - self.$refs.table.$el.offsetTop - this.minuend;
                            }
                        };
                    } else {
                        if (this.$refs.table && this.$refs.table.$el) {
                            if (this.tableHeight && this.tableHeight.indexOf('px') === -1) {
                                this.tableAutoHeight = this.tableHeight - this.$refs.table.$el.offsetTop + 'px';
                            } else {
                                this.tableAutoHeight = this.tableHeight - this.$refs.table.$el.offsetTop;
                            }
                        }
                    }
                }
            }
        });
    },
    methods: {
        jumpLinks (url) {
            let zz = '(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]';
            let reg = new RegExp(zz);
            if (!reg.test(url)) {
                this.$message.error('链接地址不合法,请修改。');
                return false;
            }
            window.open(url);
        },
        setMergeSpanArr (data) {
            this.spanArr = [];
            for (var i = 0; i < data.length; i++) {
                this.spanArr[i] = 0;
                if (data[i].rowspan) { // 判断是否包含合并单元格信息
                    this.spanArr[i] = data[i].rowspan;
                }
            }
        },
        cellMerge ({ row, column, rowIndex, columnIndex }) {
            if (this.isSubform) {
                if (this.isShowCheckbox && columnIndex > 0) {
                    columnIndex--;
                }
                if (this.subformTableColumns) {
                    if (this.subformTableColumns[columnIndex]) {
                        this.maxOperIndex = this.subformTableColumns.length;
                    }
                    if ((this.subformTableColumns[columnIndex] && !this.subformTableColumns[columnIndex].sub) || (this.maxOperIndex !== 0 && columnIndex === this.maxOperIndex)) {
                        const _row = this.spanArr[rowIndex];
                        const _col = _row > 0 ? 1 : 0;
                        let obj = {
                            rowspan: _row,
                            colspan: _col
                        };
                        return obj;
                    }
                }
            }
        },
        handleCopyFile () {
            if (this.selectArchiveField === '' || this.selectArchiveField.length === 0) {
                this.$message({message: '请选择要复制的目标字段', type: 'warning'});
                return false;
            } else {
                let selectArchiveFieldObj = this.arhiveFieldList.filter(item => {
                    return item.id === this.selectArchiveField;
                });
                this.$refs.fieldItemArchive.handleCopyFileToTarget(selectArchiveFieldObj[0]);// 复制文件列表内容
            }
        },
        handleQueryData (currentPage) {
            this.$emit('changePage', {
                currentPage
            });
        },
        handleQueryDataByPageSize (pageSize) {
            this.$emit('changePageSize', {
                pageSize
            });
        },
        deleteRowClick (row, column) {
            let id = row.id;
            this.$emit('deleteRowClick', id);
        },
        async handleRowClick (row, column, event) {
            // console.log(column);
            let chooseField = '';
            // console.log(this.subformFieldsList);
            // console.log(this.fieldsList);
            if (Array.isArray(this.subformFieldsList) && this.subformFieldsList.length > 0) {
                this.subformFieldsList.forEach(item => {
                    if (item.id === column.property) {
                        chooseField = item;
                    }
                });
                if (isEmpty(this.arhiveFieldList)) {
                    if (Array.isArray(this.fieldsList) && this.fieldsList.length > 0) {
                        this.fieldsList.forEach(item => {
                            if (item.type === 'archive') {
                                this.arhiveFieldList.push(item);
                            }
                        });
                    }
                }
            } else if (Array.isArray(this.fieldsList) && this.fieldsList.length > 0) {
                this.fieldsList.forEach(item => {
                    if (column && column.property && (item.id === column.property)) {
                        chooseField = item;
                    }
                });
            }
            if (!chooseField) { // 查询关联字段子表单里的属性值
                let fieldArr = await getFormFieldListByIds(column.property);
                if (Array.isArray(fieldArr) && fieldArr.length > 0) {
                    chooseField = fieldArr[0];
                }
            }
            // console.log(chooseField);
            if (chooseField && chooseField.type === 'archive') {
                this.loadTimer = new Date().getTime();
                this.field = chooseField;
                this.formData = row;
                this.isShowFieldItemArchive = true;
            } else if (chooseField && chooseField.type === 'text' && chooseField.options.ext3 === '1') {
                this.richtextContent = row[column.property];
                this.loadTimer = new Date().getTime();
                this.isShowRichtextContent = true;
            } else if (column.property !== 'processInstanceName') {
                this.$emit('rowClick', {
                    row: row
                });
            }
        },
        handleRowDblclick (row, column, event) {
            // console.log(row);
            this.$emit('rowDblclick', {
                row: row
            });
        },
        // handleCellClick (row, column, cell, event) {
        //     let currentCell = this.tableColumns.find(element => element.prop === column.property);
        //     if (currentCell.isAggregate) {
        //     }
        // },
        showAggregateDetail (row, column) {
            if (column.aggregateSearchConditionId) {
                this.aggregateSelectedModel.id = column.aggregateModelId;// 当前聚合表字段所在model id
                this.aggregateSelectedModel.formId = column.aggregateFormId;// 当前聚合表字段所在form id
                this.aggregateSelectedModel.modelType = 1;// modelType 1 表单  2 报表 3 BI 4审批
                this.aggregateSelectedModel.leftTreeMode = false;
                this.aggregateSelectedModel.resetPage = true;
                this.aggregateFormName = '当前表单：【' + column.aggregateFormName + '】';
                let searchConditionExt = [];
                // this.tableColumns.forEach((mainItem, index) => {
                // if (!mainItem.isAggregate && mainItem.type !== 'index' && column.aggregateSearchConditionId) {
                if (column.aggregateSearchConditionId) {
                    let condition = {
                        // id: column.aggregateFieldId,
                        id: column.aggregateSearchConditionId,
                        type: column.aggregateFieldType,
                        formId: column.aggregateFormId,
                        operateType: 1,
                        modelId: column.aggregateModelId,
                        conditionValue: row[column.aggregateConditionValueId]
                        // conditionValue: row[mainItem.prop]
                    };
                    if (condition.type === 'user' || condition.type === 'dictionary' || condition.type === 'businessTree' || condition.type === 'department' || condition.type === 'process') {
                        // condition.conditionValueView = row[mainItem.prop];
                        condition.conditionValueView = row[column.aggregateConditionValueId];
                    } else if (condition.type === 'link') {
                        condition.searchFieldId = column.aggregateSearchConditionId + '-view';
                    }
                    searchConditionExt.push(condition);
                    if (column.searchConditionSetting) { // 增加聚合表配置的查询条件
                        searchConditionExt = searchConditionExt.concat(JSON.parse(column.searchConditionSetting));
                    }
                }
                // });
                this.renderModelFormList(this.aggregateSelectedModel, searchConditionExt);
            } else {
                this.$message({message: '当前聚合表字段没有设置数据钻取查条件，请联系管理员进行配置', type: 'warning'});
            }
        },
        async renderModelFormList (model, searchConditionExt) {
            this.loadTimerModelFormList = new Date().getTime();
            this.isShowModelFormList = true;
            setTimeout(() => {
                // 调用子组件的方法
                this.$refs.formListChild.renderFormList(model, false, searchConditionExt);
            }, 0);
        },
        sortChange (column, key, order) {
            // console.log(column);
            // console.log(order);
            // console.log(this.fieldsList);
            // console.log(this.selectedModel);
            if (this.selectedModel && this.selectedModel.modelType === 6) {
                this.pageSortChange(column);
            } else if (Array.isArray(this.fieldsList) && this.fieldsList.length > 0) {
                let chooseField = '';
                this.fieldsList.forEach(item => {
                    // console.log(item);
                    if (item.id === column.prop) {
                    // if (item.id === column.prop || (item.id + '-user' === column.prop) || (item.id + '-tree' === column.prop && item.type === 'department')) {
                        chooseField = item;
                        chooseField.orderByRule = column.order === 'descending' ? 'DESC' : 'ASC';
                    }
                });
                // console.log(chooseField);
                if (chooseField !== '') {
                    this.$emit('searchOrderby', chooseField);
                }
            }
        },
        // 自定义排序
        pageSortChange (column) {
            /**
             * 思路：
             * 首先将空值或者说不符合要去的行数据过滤掉，形成新的数组
             * 对新的数组进行常规升/降序排序，根据传入的column.order判断是升序还是降序 let sortingType = column.order
             * 如果点击表头取消排序也需要做判断，将数据还原成接口返回的数据
             *
             */
            let currentTableData = cloneDeep(this.tableData);
            let tempTableList = [];
            let tempTableData = [];
            // 获取字段名称和排序类型
            let fieldName = column.prop;
            let sortingType = column.order;
            // 过滤出不符合排序的数据形成新数组，最后将新数组的数据放入到排序后的数组中，保证数据的完整性。这里去掉为0或者其它内容的数据
            tempTableList = Object.assign([], currentTableData.filter(el => (el[fieldName] === '0' || el[fieldName] === undefined)));
            // 过滤出符合排序的数据形成新数组，再对该数组进行常规排序
            tempTableData = Object.assign([], currentTableData.filter(el => (el[fieldName] !== '0' && el[fieldName] !== undefined)));
            // console.log(tempTableList);
            // console.log(tempTableData);
            if (sortingType !== null) {
                if (sortingType === 'descending') { // 按照降序排序
                    // 冒泡排序新数组
                    // tempTableData = tempTableData.sort((a, b) => b[fieldName] - a[fieldName]);
                    tempTableData = tempTableData.sort(function (a, b) {
                        return b[fieldName] - a[fieldName];
                    });
                    // 将不符合排序的数组重新放入排序完成的数组末尾，保证数据完整
                    // tempTableData.reverse();
                    tempTableList.forEach(el => {
                        tempTableData.push(el);
                    });
                } else { // 按照升序排序
                    // 冒泡排序新数组
                    // tempTableData = tempTableData.sort((a, b) => a[fieldName] - b[fieldName]);
                    tempTableData = tempTableData.sort(function (a, b) {
                        return a[fieldName] - b[fieldName];
                    });
                    // 将不符合排序的数组重新放入排序完成的数组末尾，保证数据完整
                    tempTableList.forEach(el => {
                        tempTableData.unshift(el);// 向头部添加数组
                    });
                }
                this.resetNum(tempTableData);
                currentTableData = Object.assign([], tempTableData);
                this.refreshDynamicTableKey = new Date().getTime();
            } else {
                // 如果是取消排序，则将数据还原成接口返回的数据
                currentTableData = cloneDeep(this.tableData);
                this.refreshDynamicTableKey = new Date().getTime();
            }
            this.tableData = currentTableData;
        },
        resetNum (listData) {
            let newIndex = 1;
            listData.forEach(el => {
                el.num = newIndex;
                newIndex++;
            });
        },
        indexMethod (index) {
            return index;
        },
        setRowStyle (row) {
            return 'cursor: pointer;';
        },
        handleSelectionChange (val) { // 多选
            // console.log(val);
            // 解决全选下，含子表单的数据，多出几条子项数据的问题
            let val_ = [];
            for (var i = 0; i < val.length; i++) {
                let item = val[i];
                if (item.id && item.id !== 'undefined') {
                    val_.push(item);
                }
            }
            // console.log(val_);
            let ids = '';
            let isHasUNDel = false;
            let unDelNums = '';// 不可删除的数据序号
            let unDelNumsCnt = 0;
            for (let i = 0; i < val_.length; i++) {
                if (!val_[i].isCanDelete) { // 筛选不可删除的数据
                    isHasUNDel = true;
                    if (unDelNumsCnt === 0) {
                        unDelNums = val_[i].num;
                    } else {
                        unDelNums = unDelNums + ',' + val_[i].num;
                    }
                    unDelNumsCnt++;
                }
                if (i === 0) {
                    ids = val_[i].id;
                } else {
                    ids = ids + ',' + val_[i].id;
                }
            }
            this.$emit('selectionChange', {ids: ids, isHasUNDel: isHasUNDel, unDelNums: unDelNums, unDelNumsCnt: unDelNumsCnt});
        },
        getSummaries (param) {
            // 将计算属性过滤出来
            let tableColumns_ = [];
            this.tableColumns.forEach((mainItem, index) => {
                if (mainItem.type === 'number' || mainItem.type === 'calculation' || mainItem.type === 'subFormSummary' || mainItem.isAggregate) {
                    tableColumns_.push(mainItem);
                }
                if (mainItem.type === 'subform') {
                    let subColumns = mainItem.subColumns;
                    // console.log(subColumns);
                    subColumns.forEach((subItem) => {
                        // console.log(subItem);
                        if (subItem.type === 'number' || subItem.type === 'calculation') {
                            tableColumns_.push(subItem);
                        }
                    });
                }
            });
            let { columns, data } = param;
            let sums = [];
            columns.forEach((column, index) => {
                if (this.isShowCheckbox && index === 0) {
                    sums[index] = '';
                    return;
                }
                if (column.property === 'num') {
                    sums[index] = '合计';
                    return;
                }
                if (tableColumns_ && tableColumns_.length > 0) {
                    for (var i = 0; i < tableColumns_.length; i++) {
                        let item = tableColumns_[i];
                        if (item.prop === column.property) {
                            let values = data.map(item => Number(item[column.property]));
                            if (!values.every(value => isNaN(value))) {
                                sums[index] = values.reduce((prev, curr) => {
                                    let value = Number(curr);
                                    if (!isNaN(value)) {
                                        return prev + curr;
                                    } else {
                                        return prev;
                                    }
                                }, 0);
                                // 四舍五入保留两位小数
                                sums[index] = this.$options.filters['moneyFomater'](sums[index].toFixed(2));
                            } else {
                                // sums[index] = '---';
                            }
                        }
                    }
                } else { // TODO
                }
            });
            return sums;
        },
        getApprovalList (approvalInstanceId) {
            let resList = [];
            if (this.approvalList && this.approvalList.length > 0) {
                this.approvalList.forEach((approval, index) => {
                    if (approval && approval.id === approvalInstanceId) {
                        resList.push(approval);
                    }
                });
            }
            return resList;
        },
        filterChange (filters) {
            let approvalStatus = '';
            if (filters && filters.approvalStatusFilterKey && filters.approvalStatusFilterKey.length > 0) {
                approvalStatus = filters.approvalStatusFilterKey.join(',');
            }
            this.$emit('filterChange', approvalStatus);
        },
        getProgressStatus (value, column) {
            let status = '';
            if (column.type === 'number' && column.isProgress) {
                if (value[column.progressDateField]) {
                    let targetTime = value[column.progressDateField];
                    if (Array.isArray(targetTime)) {
                        targetTime = targetTime[1];// 取截止时间
                    }
                    let progressData = value[column.prop];// 当前进度值
                    progressData = progressData ? parseInt(progressData) : 0;
                    let progressTime = new Date(targetTime).getTime();
                    let currentTime = new Date().getTime();
                    if (progressData === 100) { // 当前时间等于目标时间，且进度等于100
                        status = 'success';
                        value.showProgressStatus = true;
                    } else if (progressTime < currentTime && progressData < 100) { // 当前时间 大于 截止目标时间，且进度小于100
                        value.showProgressStatus = true;
                        status = 'exception';
                    }
                    return status;
                }
            }
            return status;
        },
        hideDialog () {
            this.isShowModelFormList = false;
        },
        titleMouseover (e, column) {
            column.isShowSearchBtn = true;
            this.refreshDynamicTableKey = new Date().getTime();
        },
        titleMouseout (e, column) {
            column.isShowSearchBtn = false;
            this.refreshDynamicTableKey = new Date().getTime();
        },
        filterHead (column) {
            this.currentColumn = column;
            this.resetSearchConditon(column, 1);
        },
        async chooseSearchConditon (column) {
            this.isShowSearchConditon = false;
            let searchCondition = this.$refs.searchConditon.getSearchCondition();
            // this.searchParams.searchCondition = searchCondition;
            // this.page.currentPage = 1;
            if (!isEmpty(searchCondition)) {
                searchCondition.forEach(element => {
                    if (!this.conditionLocalMap.has(element.id)) {
                        this.conditionLocalMap.set(element.id, element);
                    }
                });
            } else {
                searchCondition = [];
                for (let [key, value] of this.conditionLocalMap) {
                    if (key === this.currentColumn.id || key === column.id) {
                        this.conditionLocalMap.delete(key);
                    }
                }
            }
            for (let i = 0; i < searchCondition.length; i++) {
                let cur = searchCondition[i];
                if (cur.type === 'link') {
                    cur.searchFieldId = cur.id + '-view';
                }
            }
            this.$emit('searchOrderby', searchCondition);
            // this.queryFormData(this.page);
        },
        async resetSearchConditon (column, opt) {
            this.conditionFields = [];
            if (!isEmpty(this.conditionLocalMap)) {
                this.conditionLocalMap.forEach(element => {
                    if (opt && opt === 1) {
                        if (element.id === column.prop) {
                            this.conditionFields.push(element);
                        }
                    }
                });
            }
            if (isEmpty(this.conditionFields)) {
                let columns = cloneDeep(this.tableColumns);
                let idArr = [];
                columns.forEach(item => {
                    if (column && column.id === item.id) {
                        idArr.push(item.id);
                    }
                });
                this.conditionFields = await getFormFieldListByIds(idArr.join(','));
            }
            // this.page.currentPage = 1;
            this.isShowSearchConditon = true;
            this.searchLoaderTime = new Date().getTime();
        },
        labelHead (h, { column, $index }) {
            let l = column.label.length;
            let f = 16;
            column.minWidth = f * (l + 2);// 加上一个文字长度
            return h('div', { class: 'table-head', style: { width: '100%' } }, [column.label]);
        }
    }
};
</script>

<style lang="less" scoped>
    /* .dynamic-table {
        .header-label {
            &:hover {
                .header-label-icon {
                    display: inherit;
                }
            }
        }
        .header-label-icon {
            cursor: pointer;
            display: none;
        }
    } */
    .field-item-link-pop{
      margin: 0 auto;
    }

    .richtext-content {
            display: -webkit-flex;
            -webkit-justify-content: center;
            -webkit-align-items: center;
            table {
              border:none;
              border-collapse:collapse;
            }
            table td,
            table th{
              border: 1px solid #ccc;
              padding: 3px 5px;
              min-width: 50px;
              height: 20px;
            }
            table th {
              border-right: 1px solid #ccc;
              border-bottom: 2px solid #ccc;
              text-align: center;
              background-color: #f1f1f1;
            }
            blockquote{
              display: block;
              border-left: 8px solid #d0e5f2;
              padding: 5px 10px;
              margin: 10px 0;
              line-height: 1.4;
              font-size: 100%;
              background-color: #f1f1f1;
            }
            code{
              display: inline-block;
              *display: inline;
              *zoom: 1;
              background-color: #f1f1f1;
              border-radius: 3px;
              padding: 3px 5px;
              margin: 0 3px;
            }
            pre code {
              display: block;
            }
            ul, ol{
              margin: 10px 0 10px 20px;
            }
            pre {
              border: 1px solid #ccc;
              background-color: #f8f8f8;
              padding: 10px;
              margin: 5px 0px;
              font-size: 0.8em;
              border-radius: 3px;
            }
            .ql-editor ul li {
                list-style-type: disc;    // 解决序列li前面的.不展示问题
            }
            .ql-editor ol li {
                list-style-type: decimal;   // 解决序列li前面的数字不展示问题
            }
        }
        .opera-form-btn{
            color: #cd0000;
            text-align: center;
            .opera-form-btn-item{
                margin-left: 10px;
                cursor: pointer;
            }
        }
        .popModelFormList {
          .el-dialog__body {
              padding: 5px 30px 0px 0px;
              color: #606266;
              font-size: 14px;
              word-break: break-all;
              height: ~"calc(100% - 8vh)";
          }
      }

      .center-menu {
        display: flex;
        cursor: pointer;
        height: 60px;
        line-height: 60px;
        background: #ecf5ff;

        .menu-system {
            flex: 1;
            display: flex;

            .menu-system-item {
                width: 100px;
                position: relative;
                text-align: center;

                .menu-system-item-child,
                .menu-system-item-child-group {
                    display: none;
                }

                @media screen and (min-width: 1024px) and (max-width: 1366px) {
                    width: 88px;
                    font-size: 16px;
                }
            }

            .menu-system-item:hover {
                background: #d4e4f5;

                .menu-system-item-child {
                    display: block;
                    z-index: 100;
                    background: #FFFFFF;
                    min-height: 100px;
                    width: 400px;
                    // max-height: 90vh;
                    overflow: auto;
                    position: absolute;
                    border: 1.2px solid #e6e3e3;
                    display: flex;
                    flex-wrap: wrap;
                    padding-bottom: 20px;
                    margin-top: -2px;
                    overflow: auto;
                    max-height: 80vh;

                    .menu-system-child {
                        min-width: 160px;
                        width: auto;
                        text-align: left;
                        height: 40px;
                        line-height: 40px;
                        padding-left: 20px;
                        cursor: pointer;
                    }

                    .menu-system-child:hover {
                        background: #d4e4f5;
                    }

                    @media screen and (min-width: 1024px) and (max-width: 1366px) {
                        position: relative;
                        right: 200px;
                    }
                }

                .menu-system-item-child-group {
                    display: block;
                    z-index: 100;
                    background: #FFFFFF;
                    min-height: 100px;
                    width: auto;
                    max-height: 90vh;
                    overflow: auto;
                    position: absolute;
                    border: 1.2px solid #e6e3e3;
                    display: flex;
                    margin-top: -2px;

                    .menu-system-child {
                        min-width: 160px;
                        width: auto;
                        text-align: left;
                        padding-left: 20px;
                        cursor: pointer;
                        font-size: 20px;

                        .iconfont {
                            font-size: 20px;
                        }

                        padding-bottom: 20px;

                        .menu-system-child-item {
                            width: 140px;
                            text-align: left;
                            height: 40px;
                            line-height: 40px;
                            padding-left: 20px;
                            cursor: pointer;
                            padding-left: 16px;
                            font-size: 16px;

                            .iconfont {
                                font-size: 16px;
                            }
                        }

                        .menu-system-child-item:hover {
                            background: #d4e4f5;
                        }
                    }
                }
            }

            .menu-system-item:last-child {
                .menu-system-item-child-group {
                    position: absolute;
                    right: -174px;
                }
            }
        }
      }

  .caret-wrapper {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    height: 34px;
    width: 24px;
    /* vertical-align: middle; */
    cursor: pointer;
    overflow: initial;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/DynamicTable/DynamicTable.vue